var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5614 11.2481C13.7558 11.5814 13.5154 12 13.1295 12H0.870519C0.484623 12 0.244188 11.5814 0.438629 11.2481L6.56811 0.740381C6.76105 0.409629 7.23895 0.409629 7.43189 0.740382L13.5614 11.2481Z",
    fill: "url(#paint0_linear_5866_65625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5604 8.61187H6.45837L6.22803 4.19922H7.79075L7.5604 8.61187ZM6.20996 10.1565C6.20996 9.87349 6.28674 9.67476 6.4403 9.56035C6.59688 9.44593 6.78507 9.38872 7.00487 9.38872C7.21865 9.38872 7.40233 9.44593 7.55589 9.56035C7.71246 9.67476 7.79075 9.87349 7.79075 10.1565C7.79075 10.4275 7.71246 10.6232 7.55589 10.7437C7.40233 10.8641 7.21865 10.9243 7.00487 10.9243C6.78507 10.9243 6.59688 10.8641 6.4403 10.7437C6.28674 10.6232 6.20996 10.4275 6.20996 10.1565Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5866_65625",
    x1: 4.75868,
    y1: 3.89953,
    x2: 10.6781,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB84D"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.8e732fec8552ab394ee1adb94ca92b00.svg";